import { TextInput } from '@components';
import { Field, useFormikContext } from 'formik';
import React from 'react';

export const Contato = () => {
  const { setFieldValue } = useFormikContext();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="mb-32 ts-16 fw-bold">Dados de contato</h3>
        <div className="row">
          <div className="col-12 col-md-6">
            <Field
              name="email"
              className="mb-3"
              component={TextInput}
              label="E-mail principal"
            />
          </div>
          <div className="col-12 col-md-6">
            <Field
              name="celular"
              className="mb-3"
              inputMode="numeric"
              component={TextInput}
              label="Celular"
              onChange={(e) => {
                setFieldValue('celular', e.target.value);
              }}
            />
          </div>

          <div className="col-12 col-md-6">
            <Field
              name="telefoneFixo"
              className="mb-3"
              inputMode="numeric"
              component={TextInput}
              label="Telefone fixo"
              onChange={(e) => {
                setFieldValue('telefoneFixo', e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
